import {
  collection, addDoc, query, orderBy, limit, getDocs, serverTimestamp, Timestamp,
} from "firebase/firestore";
import { db, auth } from "../firebase";

// Append-only audit log shared with the Cloud Functions. Client entries are
// stamped with the signed-in admin's uid and the server time; rules reject any
// other actor and forbid edits or deletes, so the trail is tamper evident.

export interface AuditEntry {
  id: string;
  at: Date | null;
  actorEmail: string;
  summary: string;
}

// Log a config change. Best-effort: a logging failure must never block the
// change the admin just made, so callers fire-and-forget this.
export async function logAudit(summary: string): Promise<void> {
  const user = auth.currentUser;
  if (!user) return;
  try {
    await addDoc(collection(db, "audit"), {
      at: serverTimestamp(),
      actorUid: user.uid,
      actorEmail: user.email ?? "",
      summary,
    });
  } catch (e) {
    console.warn("Audit log write skipped:", e);
  }
}

export async function listAudit(max = 100): Promise<AuditEntry[]> {
  const q = query(collection(db, "audit"), orderBy("at", "desc"), limit(max));
  const snap = await getDocs(q);
  return snap.docs.map((d) => {
    const r = d.data();
    const at = r.at instanceof Timestamp ? r.at.toDate() : null;
    return {
      id: d.id,
      at,
      actorEmail: typeof r.actorEmail === "string" ? r.actorEmail : "",
      summary: typeof r.summary === "string" ? r.summary : "",
    };
  });
}
